"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _router = require("@reach/router");

var _antd = require("antd");

var _Input = _interopRequireDefault(require("./Input"));

var _actions = require("../actions");

var _routes = require("../routes");

var _utils = require("../utils");

var _theme = require("../theme");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var LoginForm = function LoginForm(props) {
  var url = props.url;

  var _ref = (0, _react.useState)({
    email: '',
    password: '',
    error: null,
    success: null,
    loading: false,
    form: null
  }),
      _ref2 = _slicedToArray(_ref, 2),
      data = _ref2[0],
      setData = _ref2[1];

  var action = (0, _utils.getParameter)('action');
  var key = (0, _utils.getParameter)('key');
  var login = (0, _utils.getParameter)('login');

  var isAuthed = _utils.auth.isLoggedIn();

  (0, _react.useEffect)(function () {
    setData(_objectSpread(_objectSpread({}, data), {}, {
      form: action && key && login ? action : 'login'
    }));
  }, [action]);
  (0, _react.useEffect)(function () {
    isAuthed && (0, _router.navigate)(_routes.ROUTE_APP);
  }, [isAuthed]);

  var handleChange = function handleChange(e) {
    return setData(_objectSpread(_objectSpread({}, data), {}, _defineProperty({
      error: null
    }, e.target.name, e.target.value)));
  };

  var handleLogin = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var email, password, _result$data, _result$data$login, _result$data$login$us, _result$errors, _result$errors$, result;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              email = data.email, password = data.password;

              if (email) {
                _context.next = 4;
                break;
              }

              setData(_objectSpread(_objectSpread({}, data), {}, {
                error: 'Email address is required'
              }));
              return _context.abrupt("return");

            case 4:
              if ((0, _utils.validateEmail)(email)) {
                _context.next = 7;
                break;
              }

              setData(_objectSpread(_objectSpread({}, data), {}, {
                error: 'Email address is invalid'
              }));
              return _context.abrupt("return");

            case 7:
              if (password) {
                _context.next = 10;
                break;
              }

              setData(_objectSpread(_objectSpread({}, data), {}, {
                error: 'Password is required'
              }));
              return _context.abrupt("return");

            case 10:
              setData(_objectSpread(_objectSpread({}, data), {}, {
                loading: true
              }));
              _context.prev = 11;
              _context.next = 14;
              return _actions.authActions.signIn({
                email: email,
                password: password
              }, url);

            case 14:
              result = _context.sent;

              if (!(result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && (_result$data$login = _result$data.login) !== null && _result$data$login !== void 0 && (_result$data$login$us = _result$data$login.user) !== null && _result$data$login$us !== void 0 && _result$data$login$us.capabilities.includes('edit_posts')) || result !== null && result !== void 0 && (_result$errors = result.errors) !== null && _result$errors !== void 0 && (_result$errors$ = _result$errors[0]) !== null && _result$errors$ !== void 0 && _result$errors$.message) {
                setData(_objectSpread(_objectSpread({}, data), {}, {
                  error: 'Email or password wrong.'
                }));
              } else {
                (0, _router.navigate)(_routes.ROUTE_APP);
              }

              _context.next = 21;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](11);
              console.log('error...: ', _context.t0);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[11, 18]]);
    }));

    return function handleLogin() {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleForgetPassword = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var email, _result$data2, result, _result$errors2, _result$errors2$;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              email = data.email;

              if (email) {
                _context2.next = 4;
                break;
              }

              setData(_objectSpread(_objectSpread({}, data), {}, {
                error: 'Email address is required'
              }));
              return _context2.abrupt("return");

            case 4:
              if ((0, _utils.validateEmail)(email)) {
                _context2.next = 7;
                break;
              }

              setData(_objectSpread(_objectSpread({}, data), {}, {
                error: 'Email address is invalid'
              }));
              return _context2.abrupt("return");

            case 7:
              setData(_objectSpread(_objectSpread({}, data), {}, {
                loading: true
              }));
              _context2.prev = 8;
              _context2.next = 11;
              return _actions.authActions.forgetPassword({
                email: email
              }, url);

            case 11:
              result = _context2.sent;

              if (result !== null && result !== void 0 && (_result$data2 = result.data) !== null && _result$data2 !== void 0 && _result$data2.sendPasswordResetEmail) {
                setData(_objectSpread(_objectSpread({}, data), {}, {
                  success: /*#__PURE__*/_react.default.createElement("p", null, "Success. An email has been sent to ".concat(email, " with further instructions.")),
                  loading: false
                }));
              } else {
                setData(_objectSpread(_objectSpread({}, data), {}, {
                  error: result === null || result === void 0 ? void 0 : (_result$errors2 = result.errors) === null || _result$errors2 === void 0 ? void 0 : (_result$errors2$ = _result$errors2[0]) === null || _result$errors2$ === void 0 ? void 0 : _result$errors2$.message,
                  loading: false
                }));
              }

              _context2.next = 18;
              break;

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](8);
              console.log('error...: ', _context2.t0);

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[8, 15]]);
    }));

    return function handleForgetPassword() {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleSetPassword = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var password, _result$data3, result, _result$errors3, _result$errors3$;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              password = data.password;

              if (password) {
                _context3.next = 4;
                break;
              }

              setData(_objectSpread(_objectSpread({}, data), {}, {
                error: 'Password is required'
              }));
              return _context3.abrupt("return");

            case 4:
              setData(_objectSpread(_objectSpread({}, data), {}, {
                loading: true
              }));
              _context3.prev = 5;
              _context3.next = 8;
              return _actions.authActions.resetPassword({
                key: key,
                login: login,
                password: password
              }, url);

            case 8:
              result = _context3.sent;

              if (result !== null && result !== void 0 && (_result$data3 = result.data) !== null && _result$data3 !== void 0 && _result$data3.resetUserPassword) {
                setData(_objectSpread(_objectSpread({}, data), {}, {
                  password: '',
                  success: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "Password set successfully."), /*#__PURE__*/_react.default.createElement(_antd.Button, {
                    children: "Back to Login",
                    onClick: function onClick() {
                      return setData(_objectSpread(_objectSpread({}, data), {}, {
                        form: 'login'
                      }));
                    },
                    type: "primary",
                    block: true
                  })),
                  loading: false
                }));
              } else {
                setData(_objectSpread(_objectSpread({}, data), {}, {
                  error: result === null || result === void 0 ? void 0 : (_result$errors3 = result.errors) === null || _result$errors3 === void 0 ? void 0 : (_result$errors3$ = _result$errors3[0]) === null || _result$errors3$ === void 0 ? void 0 : _result$errors3$.message,
                  loading: false
                }));
              }

              _context3.next = 15;
              break;

            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](5);
              console.log('error...: ', _context3.t0);

            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[5, 12]]);
    }));

    return function handleSetPassword() {
      return _ref5.apply(this, arguments);
    };
  }();

  var getFormData = function getFormData() {
    switch (data.form) {
      case 'login':
        return {
          title: 'Login',
          handleSubmit: function handleSubmit() {
            return handleLogin();
          }
        };

      case 'forget':
        return {
          title: 'Forgot Password',
          handleSubmit: function handleSubmit() {
            return handleForgetPassword();
          }
        };

      case 'reset':
        return {
          title: 'Set Password',
          handleSubmit: function handleSubmit() {
            return handleSetPassword();
          }
        };

      default:
    }
  };

  var formData = getFormData();
  return /*#__PURE__*/_react.default.createElement(Container, null, (data === null || data === void 0 ? void 0 : data.form) && /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: formData === null || formData === void 0 ? void 0 : formData.title
  }, url ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, data !== null && data !== void 0 && data.success ? /*#__PURE__*/_react.default.createElement(Success, {
    children: data.success
  }) : /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 20
  }, /*#__PURE__*/_react.default.createElement(_antd.Form, {
    onFinish: formData === null || formData === void 0 ? void 0 : formData.handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 20
  }, (data.form === 'login' || data.form === 'forget') && /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Email",
    value: data.email,
    onChange: handleChange,
    onKeyDown: function onKeyDown(e) {
      return e.key === 'Enter' && (formData === null || formData === void 0 ? void 0 : formData.handleSubmit);
    },
    name: "email"
  }), (data.form === 'login' || data.form === 'reset') && /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Password",
    value: data.password,
    type: "password",
    onChange: handleChange,
    onKeyDown: function onKeyDown(e) {
      return e.key === 'Enter' && (formData === null || formData === void 0 ? void 0 : formData.handleSubmit);
    },
    name: "password"
  }), (data === null || data === void 0 ? void 0 : data.error) && /*#__PURE__*/_react.default.createElement(Error, {
    children: data.error
  }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    loading: data.loading,
    children: "Submit",
    type: "primary",
    htmlType: "submit",
    block: true
  }))), /*#__PURE__*/_react.default.createElement(FooterLink, {
    onClick: function onClick() {
      return handleChange({
        target: {
          name: 'form',
          value: data.form === 'login' ? 'forget' : 'login'
        }
      });
    }
  }, data.form === 'login' ? 'Forgot password?' : 'Back to Login'))) : /*#__PURE__*/_react.default.createElement("p", null, "Please provide a URL.")));
};

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  .ant-space {\n    width: 100%;\n  }\n"])));

var Success = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n"])), _theme.colors.success);

var Error = _styledComponents.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  margin-top: 10px;\n  color: ", ";\n"])), _theme.colors.warning);

var FooterLink = _styledComponents.default.p(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  margin: 10px 0 0;\n  text-align: center;\n  color: ", ";\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"])), _theme.colors.primary);

var _default = LoginForm;
exports.default = _default;